export default __webpack_public_path__ + "95f5340bf1666ac0c9c0dd653c0f30e6.png";